import { z } from "zod";
import { MAX_PRODUCT_IMAGES } from "@ac-expo/utils";
import { fileSchema } from "../files/files.schema";

export const baseProductSchema = z.object({
  name: z.string().min(1, "Le nom du produit est requis"),
  images: z
    .array(fileSchema)
    .min(1, "Au moins une image est requise")
    .max(MAX_PRODUCT_IMAGES, `Maximum ${MAX_PRODUCT_IMAGES} images autorisées`),
  description: z.string().optional(),
  link: z.string().url("URL invalide").optional().or(z.literal("")),
});

export const defaultBaseProductValues: BaseProductForm = {
  name: "",
  images: [],
  description: "",
  link: "",
};

export type BaseProductForm = z.infer<typeof baseProductSchema>;
